import { Button } from 'components/Button/Button'
import { getInitials } from 'utils'
import Avatar from 'common/Avatar/Avatar'

import Styles from './SwitchAccount.module.scss'

interface Props {
  email: string
  displayName: string | null
  avatarURL: string | null
  onSwitchAccount: () => void
  isDisabled?: boolean
}

const SwitchAccount = ({ email, displayName, avatarURL, onSwitchAccount, isDisabled }: Props) => {
  const avatarInitial = getInitials(displayName)
  return (
    <div className={Styles.wrapper}>
      <Avatar url={avatarURL} label={avatarInitial} size={32} />
      <div className={Styles.userInfo}>
        <p className={Styles.displayName}>{displayName}</p>
        <p className={Styles.email}>{email}</p>
      </div>
      <div className={Styles.buttonWrapper}>
        <Button isDisabled={isDisabled} size="md" variant="tertiary" onPress={onSwitchAccount}>
          Switch accounts
        </Button>
      </div>
    </div>
  )
}

export { SwitchAccount }
